import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { validateMaxInTextInput } from 'utils/helpers';
import { formInput, clearFormInput } from 'actions/FormActions';
// Basic Components
import DecimalInput from 'screens/components/basic/DecimalInput';
import DecimalInputReceiveProduct from 'screens/components/basic/DecimalInputReceiveProduct';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';

import MoodDialogInput from '../../product/Components/MoodDialogInput';
import ProductMood from '../../product/Components/ProductMood';
import ProductTerpene from '../../product/Components/ProductTerpene';
import MinorCanabinoidDialogInput from '../../product/Components/MinorCanabinoidDialogInput';
import ProductMinorCanabinoid from '../../product/Components/ProductMinorCanabinoid';
import TerpeneDialogInput from '../../product/Components/TerpeneDialogInput';

class receivedQty extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manageMoodsDialogOpen: false,
            manageTerpenesDialogOpen: false,
            manageMinorCanabinoidsDialogOpen: false
        }
    }

    componentDidMount() {
        this.props.formInput(this.props.max, `receivedQuantityDialog`);
        if (this.props.purchaseOrder && this.props.purchaseOrder.products && this.props.purchaseOrder.products.length > 0) {
            let selectedProduct = this.props.purchaseOrder.products.find(_ => _.id === this.props.productInfo.id);
            if (selectedProduct) {
                this.props.formInput((selectedProduct.thC_MAX || 0).toFixed(2), "receivedQuantityDialogTHCMAX");
                this.props.formInput((selectedProduct.thC_MIN || 0).toFixed(2), "receivedQuantityDialogTHCMIN");
                this.props.formInput((selectedProduct.cbD_MAX || 0).toFixed(2), "receivedQuantityDialogCBDMAX");
                this.props.formInput((selectedProduct.cbD_MIN || 0).toFixed(2), "receivedQuantityDialogCBDMIN");
                this.props.formInput((selectedProduct.depositAmount || 0).toFixed(2), "receivedQuantityDialogDepositAmount");
                this.props.formInput((selectedProduct.salePrice || 0).toFixed(2), "receivedQuantityDialogSalePrice");
                this.props.formInput((selectedProduct.memberSalePrice || 0).toFixed(2), "receivedQuantityDialogMemberSalePrice");
                this.props.formInput((selectedProduct.unitPrice || 0).toFixed(2), "receivedQuantityDialogUnitPrice");
                this.props.formInput(selectedProduct.location, "receivedQuantityDialogLocation");
                this.props.formInput(selectedProduct.notes, "receivedQuantityDialogNotes");
                this.props.formInput((selectedProduct.promotionPrice || 0).toFixed(2), "receivedQuantityDialogPromotionPrice");
                this.props.formInput((selectedProduct.eliteMemberSalePrice || 0).toFixed(2), "receivedQuantityDialogElitePrice");
                let margin = ((selectedProduct.salePrice - selectedProduct.unitPrice) / (selectedProduct.salePrice) * 100).toFixed(2);
                if (margin > 0) {
                    this.props.formInput(margin, "receivedQuantityDialogMargin");
                }
            } else {
                console.log("not found!!!");
            }
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput("receivedQuantityDialogTHCLevel");
        this.props.clearFormInput("receivedQuantityDialogCBDLevel");
        this.props.clearFormInput("receivedQuantityDialogTHCMAX");
        this.props.clearFormInput("receivedQuantityDialogTHCMIN");
        this.props.clearFormInput("receivedQuantityDialogCBDMAX");
        this.props.clearFormInput("receivedQuantityDialogCBDMIN");
        this.props.clearFormInput("receivedQuantityDialogDepositAmount");
        this.props.clearFormInput("receivedQuantityDialogSalePrice");
        this.props.clearFormInput("receivedQuantityDialogMemberSalePrice");
        this.props.clearFormInput("receivedQuantityDialogUnitPrice");
        this.props.clearFormInput("receivedQuantityDialogMargin");
        this.props.clearFormInput("receivedQuantityDialogLocation");
        this.props.clearFormInput("receivedQuantityDialogNotes");
        this.props.clearFormInput("receivedQuantityExpirationDate");
        this.props.clearFormInput("receivedQuantityDialogPromotionPrice");
        this.props.clearFormInput("receivedQuantityDialogElitePrice");
    }

    manageMoods = () => {
        this.setState({ manageMoodsDialogOpen: true });
    };

    closeMoodsDialog = () => {
        this.setState({ manageMoodsDialogOpen: false });
    };

    manageTerpenes = () => {
        this.setState({ manageTerpenesDialogOpen: true });
    };

    closeTerpeneDialog = () => {
        this.setState({ manageTerpenesDialogOpen: false });
    };

    manageMinorCanabinoid = () => {
        this.setState({ manageMinorCanabinoidsDialogOpen: true });
    };

    closeMinorCanabinoidDialog = () => {
        this.setState({ manageMinorCanabinoidsDialogOpen: false });
    }

    render() {
        const p = this.props;
        const disableField = p.isHighTide || p.isInspired;
        return (
            <div>
                <div className="text-center pa-2">
                    <h2>Please enter quantity of products</h2>
                </div>
                <div className="centered">
                    <TextInput
                        name={'receivedQuantityDialog'}
                        type="number"
                        hintText={"Quantity"}
                        fullWidth={true}
                        label="Quantity Received"
                        onInput={(e) => validateMaxInTextInput(e, this.props.max)}
                    />
                </div>
                <div className="text-center">
                    <h2>Product Info</h2>
                </div>
                {
                    this.props.canViewPOPriceDetail ?
                        <div className="row">
                            <div className="col-lg-6">
                                <DecimalInputReceiveProduct
                                    name={"receivedQuantityDialogUnitPrice"}
                                    fullWidth={true}
                                    label="Unit Cost Price"
                                    floatingLabelText="Unit Cost Price"
                                    hintText="Unit Cost Price"
                                    min={0}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInputReceiveProduct
                                    name={"receivedQuantityDialogMargin"}
                                    fullWidth={true}
                                    disabled={disableField}
                                    label="Margin (%) - From Regular Price"
                                    floatingLabelText="Margin (%) - From Regular Price"
                                    hintText="Margin (%) - From Regular Price"
                                    min={0}
                                    hasWarning={p.qtyMargin === "0.00"}
                                    warning={<span className='red-text remark'>Do you want to procceed with 0 margin?</span>}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInputReceiveProduct
                                    name={"receivedQuantityDialogSalePrice"}
                                    fullWidth={true}
                                    label="Regular Unit Sale Price"
                                    disabled={disableField}
                                    floatingLabelText="Regular Unit Sale Price"
                                    hintText="Regular Unit Sale Price"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInputReceiveProduct
                                    name={"receivedQuantityDialogMemberSalePrice"}
                                    fullWidth={true}
                                    disabled={disableField}
                                    label="Member Unit Sale Price"
                                    floatingLabelText="Member Unit Sale Price"
                                    hintText="Member Unit Sale Price"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInputReceiveProduct
                                    name={"receivedQuantityDialogPromotionPrice"}
                                    fullWidth={true}
                                    disabled={true}
                                    label="Promotion Price"
                                    floatingLabelText="Promotion Price"
                                    hintText="Promotion Price"
                                    min={0}
                                />
                            </div>
                            {
                                p.isHighTide &&
                                <div className="col-lg-6">
                                    <DecimalInputReceiveProduct
                                        name={"receivedQuantityDialogElitePrice"}
                                        fullWidth={true}
                                        disabled={true}
                                        label="Elite Member Sale Price"
                                        floatingLabelText="Elite Member Sale Price"
                                        hintText="Elite Member Sale Price"
                                        min={0}
                                    />
                                </div>
                            }
                        </div> :
                        <div className="row">
                            <div className="col-lg-6">
                                <DecimalInput
                                    name={"receivedQuantityDialogSalePrice"}
                                    fullWidth={true}
                                    label="Regular Unit Sale Price"
                                    disabled={true}
                                    floatingLabelText="Regular Unit Sale Price"
                                    hintText="Regular Unit Sale Price"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInputReceiveProduct
                                    name={"receivedQuantityDialogMemberSalePrice"}
                                    fullWidth={true}
                                    disabled={true}
                                    label="Member Unit Sale Price"
                                    floatingLabelText="Member Unit Sale Price"
                                    hintText="Member Unit Sale Price"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInputReceiveProduct
                                    name={"receivedQuantityDialogPromotionPrice"} ///
                                    fullWidth={true}
                                    disabled={true}
                                    label="Promotion Price"
                                    floatingLabelText="Promotion Price"
                                    hintText="Promotion Price"
                                    min={0}
                                />
                            </div>
                            {
                                p.isHighTide &&
                                <div className="col-lg-6">
                                    <DecimalInputReceiveProduct
                                        name={"receivedQuantityDialogElitePrice"}
                                        fullWidth={true}
                                        disabled={true}
                                        label="Elite Member Sale Price"
                                        floatingLabelText="Elite Member Sale Price"
                                        hintText="Elite Member Sale Price"
                                        min={0}
                                    />
                                </div>
                            }
                        </div>
                }

                {
                    (!this.props.productInfo.accessory && !this.props.isVape) ? (
                        <div className="row">
                            <div className="col-lg-6">
                                <DecimalInput
                                    name={"receivedQuantityDialogTHCLevel"}
                                    fullWidth={true}
                                    label="THC Exact Level"
                                    floatingLabelText="THC Exact Level"
                                    hintText="THC Exact Level"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInput
                                    name={"receivedQuantityDialogCBDLevel"}
                                    fullWidth={true}
                                    label="CBD Exact Level"
                                    floatingLabelText="CBD Exact Level"
                                    hintText="CBD Exact Level"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-3">
                                <DecimalInput
                                    name={"receivedQuantityDialogTHCMAX"}
                                    fullWidth={true}
                                    label="THC MAX"
                                    floatingLabelText="THC MAX *"
                                    hintText="THC MAX"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-3">
                                <DecimalInput
                                    name={"receivedQuantityDialogTHCMIN"}
                                    fullWidth={true}
                                    label="THC MIN"
                                    floatingLabelText="THC MIN *"
                                    hintText="THC MIN*"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-3">
                                <DecimalInput
                                    name={"receivedQuantityDialogCBDMAX"}
                                    fullWidth={true}
                                    label="CBD MAX"
                                    floatingLabelText="CBD MAX *"
                                    hintText="CBD MAX"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-3">
                                <DecimalInput
                                    name={"receivedQuantityDialogCBDMIN"}
                                    fullWidth={true}
                                    label="CBD MIN"
                                    floatingLabelText="CBD MIN *"
                                    hintText="CBD MIN"
                                    min={0}
                                />
                            </div>
                            <div className="col-lg-6">
                                <TextInput
                                    name={"receivedQuantityDialogLocation"}
                                    fullWidth={true}
                                    label="Location"
                                    floatingLabelText="Location"
                                    hintText="Location"
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInput
                                    name={"receivedQuantityDialogDepositAmount"}
                                    fullWidth={true}
                                    disabled={!this.props.canEditDepositAmount}
                                    label="Unit Deposit Amount"
                                    floatingLabelText="Unit Deposit Amount"
                                    hintText="Unit Deposit Amount"
                                    min={0}
                                />
                            </div>
                        </div>
                    ) :
                        (
                            <div className="row">
                                <div className="col-lg-6">
                                    <TextInput
                                        name={"receivedQuantityDialogLocation"}
                                        fullWidth={true}
                                        label="Location"
                                        floatingLabelText="Location"
                                        hintText="Location"
                                    />
                                </div>
                                {this.props.isVape ? null : (
                                    <div className="col-lg-6">
                                        <DecimalInput
                                            name={"receivedQuantityDialogDepositAmount"}
                                            fullWidth={true}
                                            disabled={!this.props.canEditDepositAmount}
                                            label="Unit Deposit Amount"
                                            floatingLabelText="Unit Deposit Amount"
                                            hintText="Unit Deposit Amount"
                                            min={0}
                                        />
                                    </div>
                                )}
                            </div>
                        )
                }
                {
                    <div className="row">
                        <div className="col-lg-12">
                            <TextInput
                                name={"receivedQuantityDialogNotes"}
                                fullWidth={true}
                                label="Notes"
                                floatingLabelText="Notes"
                                hintText="Notes"
                            />
                        </div>
                    </div>
                }

                {this.props.expirationDate != null ? <h4 className="text-center">{"Expiration/Package Date: " + moment(this.props.expirationDate).format("YYYY-MM-DD")}</h4>
                    :
                    <div className="col-lg-6">
                        <DatePickerInput
                            name={`receivedQuantityExpirationDate`}
                            floatingLabelText={"Expiration Date"}
                            hintText={"Expiration Date"}
                            fullWidth={true} />
                    </div>
                }
                {
                    (!p.isVape && p.productInfo && p.productInfo.id && !p.productInfo.accessory && p.productInfo.accessory !== null && p.productInfo.accessory !== undefined) &&
                    <div className="col-xs-12" style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                        <div>
                            <Button name="RaisedButton"
                                className="pull-left"
                                primary={true}
                                onTouchTap={this.manageTerpenes}
                                label="Manage Terpenes" />
                        </div>
                        <div>
                            <Button name="RaisedButton"
                                className="pull-left"
                                primary={true}
                                onTouchTap={this.manageMoods}
                                label="Manage Moods" />
                        </div>
                        <div>
                            <Button name="RaisedButton"
                                className="pull-left"
                                primary={true}
                                onTouchTap={this.manageMinorCanabinoid}
                                label="Manage Minor Canabinoids" />
                        </div>
                    </div>
                }
                <MoodDialogInput
                    title="MANAGE MOODS"
                    open={this.state.manageMoodsDialogOpen}
                    handleClose={() => this.closeMoodsDialog()}>
                    <br />
                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.closeMoodsDialog()}
                    />
                    <div className="no-crumb">
                        <ProductMood
                            name="dialogMood"
                            onCancel={() => this.closeMoodsDialog()}
                            productId={p.productInfo ? p.productInfo.productId : undefined}
                            pageName={"ReceivedQty"}
                            propProductName={p.productInfo && p.productInfo.productName}
                            propProductSKU={p.productInfo && p.productInfo.sku}
                        />
                    </div>
                </MoodDialogInput>
                <TerpeneDialogInput
                    title="MANAGE TERPENES"
                    open={this.state.manageTerpenesDialogOpen}
                    handleClose={() => this.closeTerpeneDialog()}
                >
                    <br />
                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.closeTerpeneDialog()}
                    />
                    <div className="no-crumb">
                        <ProductTerpene
                            name="dialogTerpene"
                            onCancel={() => this.closeTerpeneDialog()}
                            productId={p.productInfo ? p.productInfo.productId : undefined}
                            pageName={"ReceivedQty"}
                            propProductName={p.productInfo && p.productInfo.productName}
                            propProductSKU={p.productInfo && p.productInfo.sku}
                        />
                    </div>
                </TerpeneDialogInput>
                <MinorCanabinoidDialogInput
                    title="MANAGE MINOR CANABINOIDS"
                    open={this.state.manageMinorCanabinoidsDialogOpen}
                    handleClose={() => this.closeMinorCanabinoidDialog()}>
                    <br />
                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.closeMinorCanabinoidDialog()}
                    />
                    <div className="no-crumb">
                        <ProductMinorCanabinoid
                            name="dialogTerpene"
                            onCancel={() => this.closeMinorCanabinoidDialog()}
                            productId={p.productInfo ? p.productInfo.productId : undefined}
                            pageName={"ReceivedQty"}
                            propProductName={p.productInfo && p.productInfo.productName}
                            propProductSKU={p.productInfo && p.productInfo.sku}
                        />
                    </div>
                </MinorCanabinoidDialogInput>
            </div>
        );
    }
}

function mapStatetoProps(state) {
    return {
        purchaseOrder: state.entity.purchaseOrder,
        canViewPOPriceDetail: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewPOPriceDetail")),
        canEditDepositAmount: !state.common.applicationSettings.isHighTide && state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanEditDepositAmount")),
        isVape: state.common.applicationSettings.isVape,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(receivedQty);
